import { Form } from "common/Forms";
import { TableRenderer } from "common/Table";

export const TableView = ({ feeCards }) => {
  return (
    <Form>
      <TableRenderer
        data={feeCards ?? []}
        columns={
          [
            {
              name: 'Site ID',
              bodyRenderer: x => x?.siteid || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Site Name',
              bodyRenderer: x => x?.siteName || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Actions',
              widthRequest: { value: 150 },
              classNames: ['!text-center'],
              headerRenderer: (col) => (<div className="w-full text-center">{col.name}</div>),
              bodyRenderer: x => x?.actions || <div style={{ textAlign: 'center' }}>-</div>
            },
          ]
        }
      />
    </Form>
  )
}